/**
 * Created by vaibhav on 31/3/18
 */
import React from 'react'
import PropTypes from 'prop-types'
import {kebabCase} from 'lodash'
import NavBar from '../components/NavBar';
import Link from 'gatsby-link'
import Content, {HTMLContent} from '../components/Content'
import SE0 from "../components/SEO";
import Share from "../components/Share";

export const ArticleTemplate = ({
                                     content,
                                     contentComponent,
                                     cover,
                                     meta_title,
                                     meta_desc,
                                     tags,
                                     title,
                                     slug,
                                 }) => {
    const PostContent = contentComponent || Content;

    return (
        <section className="section articlecontent">
            <SE0
                title={title}
                meta_title={meta_title}
                meta_desc={meta_desc}
                cover={cover}
                slug={slug}
            />
            <NavBar/>
            <div className="container content">
                <div className="columns">
                    <div className="column is-10 is-offset-1">
                        <h1 className="title is-size-2 has-text-weight-bold is-bold-light">
                            {title}
                        </h1>
                        <img src={cover} alt={title}/>
                        <PostContent content={content}/>
                        {tags && tags.length ? (
                            <div style={{marginTop: `4rem`}}>
                                <ul className="taglist">
                                    {tags.map(tag => (
                                        <li key={tag + `tag`}>
                                            <Link to={`/tags/${kebabCase(tag)}/`}>{tag}</Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ) : null}
                        <hr/>
                        <Share
                            title={title}
                            slug={slug}
                            excerpt={meta_desc}
                        />
                        <hr/>
                    </div>
                </div>
            </div>
        </section>
    )
};

ArticleTemplate.propTypes = {
    content: PropTypes.string.isRequired,
    contentComponent: PropTypes.func,
    cover: PropTypes.string,
    meta_title: PropTypes.string,
    meta_desc: PropTypes.string,
    title: PropTypes.string,
    slug: PropTypes.string,
};

const ArticlePage = ({data}) => {
    const {markdownRemark: post} = data;
    return (
        <ArticleTemplate
            content={post.html}
            contentComponent={HTMLContent}
            cover={post.frontmatter.cover}
            meta_title={post.frontmatter.meta_title}
            meta_desc={post.frontmatter.meta_description}
            tags={post.frontmatter.tags}
            title={post.frontmatter.title}
            slug={post.fields.slug}
        />
    )
};

ArticlePage.propTypes = {
    data: PropTypes.shape({
        markdownRemark: PropTypes.object,
    }),
};

export default ArticlePage;

export const pageQuery = graphql`
  query ArticleByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      fields {
            slug
          }
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        title
        cover
        meta_title
        meta_description
        tags
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/article-page.js